/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';

function auditCountsComparator(amount1, amount2) {
  if (amount1 === null && amount2 === null) {
    return 0;
  }
  if (amount1 === null) {
    return -1;
  }
  if (amount2 === null) {
    return 1;
  }

  return amount1 - amount2;
}
export const TableHeaderForManufacturer = [
  {
    headerName: ' Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sort: 'asc',
    sortable: true,
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const TableHeaderForNDCLevelDetail = [
  {
    headerName: 'Comments Exists',
    field: 'ccCommentsExist',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    resizable: true,
    maxWidth: Styles.Width_150,
    minWidth: Styles.Width_150,
    cellRenderer: 'ActionCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    cellClass: 'ag-cell-action frr-overflow-visible',
  },
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    sort: 'asc',
    minWidth: Styles.Width_150,
    cellRenderer: 'NDCCellRender',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    sortable: true,
    columnSpan: 3,
    minWidth: Styles.Width_500,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Audits',
    field: 'auditCounts',
    comparator: auditCountsComparator,
    editable: false,
    sortable: true,
    minWidth: Styles.Width_120,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
export const TableHeaderForNDCAuditDescription = [
  {
    headerName: 'Comments Exists',
    field: 'ccCommentsExist',
    hideFilterIcon: true,
    showCheckboxIcon: true,
    editable: false,
    sortable: false,
    filter: false,
    resizable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_20,
    cellClass: 'ag-cell-action',
    cellRenderer: 'ActionCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Cleared',
    field: 'auditClearedInd',
    showCheckboxIcon: true,
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    filter: false,
    resizable: true,
    suppressMenu: false,
    minWidth: Styles.Width_100,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_20,
    cellClass: 'ag-cell-action',
    cellRenderer: 'CheckBoxCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Audit Type Cd',
    field: 'auditTypeCd',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Audit Description',
    field: 'auditText',
    editable: false,
    sortable: true,
    resizable: true,
    columnSpan: 6,
    lastColumn: true,
    minWidth: Styles.Width_530,
    sortingOrder: ['desc', 'asc'],
    autoHeight: true,
    wrapText: true,
    cellStyle: { wordBreak: 'normal' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
];
